// extracted by mini-css-extract-plugin
export default {"navLink":"navLink-d3XMR"};